export const SET_WAREHOUSES = "SET_WAREHOUSES";
export const RESET_WAREHOUSES = "RESET_WAREHOUSES";
export const SET_SPECIFIC_WAREHOUSE = "SET_SPECIFIC_WAREHOUSE";
export const RESET_SPECIFIC_WAREHOUSE = "RESET_SPECIFIC_WAREHOUSE";
